@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/typography/typography' as *;

.styledButton {
  @include border-radius-r2;
}

.styledSearchModalBase {
  li:not(:last-child) {
    border-bottom: 1px solid var(--border-soft);
  }

  [data-dropdown-list] {
    margin-bottom: 12px;
    min-height: 350px;
  }
}

.searchDescription {
  padding: 12px 20px;
  color: var(--text-soft);

  @include typography-v2-body-base;
}

.skeletonWrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 8px;

  &:not(:last-child) {
    border-bottom: 1px solid var(--border-soft);
  }
}
